import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Ch from './styled';

export const MAX_PURCHASE_ORDER_REFERENCE_LENGTH = 100;

type InvoicePurchaseOrderFieldProps = {
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
};

const InvoicePurchaseOrderField = ({
  value,
  onChange,
  error,
}: InvoicePurchaseOrderFieldProps) => {
  const { t } = useTranslation();

  return (
    <Ch.InvoiceFieldGroup>
      <Ch.InvoiceFieldLabel htmlFor="purchase-order-reference">
        {t('subscriptions.checkout.purchaseOrderReferenceLabel')}
        <Ch.InvoiceOptionalTag>
          {t('subscriptions.checkout.chf.optional')}
        </Ch.InvoiceOptionalTag>
      </Ch.InvoiceFieldLabel>
      <Ch.InvoiceTextInput
        id="purchase-order-reference"
        name="purchase_order_reference"
        type="text"
        autoComplete="off"
        maxLength={MAX_PURCHASE_ORDER_REFERENCE_LENGTH}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t(
          'subscriptions.checkout.purchaseOrderReferencePlaceholder',
        )}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? 'purchase-order-reference-error' : undefined}
      />
      {error ? (
        <Ch.InvoiceFieldError id="purchase-order-reference-error" role="alert">
          {error}
        </Ch.InvoiceFieldError>
      ) : (
        <Ch.InvoiceHint>
          {t('subscriptions.checkout.purchaseOrderReferenceHint')}
        </Ch.InvoiceHint>
      )}
    </Ch.InvoiceFieldGroup>
  );
};

export default InvoicePurchaseOrderField;
